import Splide from "@splidejs/splide";

function initSliderCardsSimple(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-cards-simple").forEach((el) => {
		const sliderCardSimple = new Splide(el, {
			perPage: 2,
			gap: "30px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			autoplay: false,
			speed: 700,
			pauseOnHover: true,
			omitEnd: true,
			breakpoints: {
				768: { perPage: 1.5, gap: "22px" },
				640: { perPage: 1.1, gap: "22px" },
			},
		});

		sliderCardSimple.on("overflow", function (isOverflow) {
			sliderCardSimple.options = {
				arrows: isOverflow,
				pagination: isOverflow,
				drag: isOverflow,
			};
		});

		sliderCardSimple.mount();


	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderCardsSimple());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-cards-simple", ($block) => {
		initSliderCardsSimple($block && $block.jquery ? $block.get(0) : $block);
	});
}
